//#region Styles
import { Column, Row } from "components/styles";
import { StyledListTimeItem } from "./styles";
//#endregion
//#region Components
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomButton from "components/CustomButton/CustomButton";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Icons
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";
import { useState } from "react";
//#endregion

const ListTimeItem = ({
    idx,
    errors, 
    date,
    inactivity,
    data: { 
        wasModified, 
        time: { start, end }, 
        date: dateItem 
    },
    customDateProps: {
        availableDay
    },
    customTimeProps: {
        ratioMinutesTime,
        intervalTimePicker,
    },
    actions: {
        changeDate,
        changeTime,
        saveChanges,
        openDialogDeleteInactivityQuestion
    }
}) => {
    //#region States
    const [errorInvalidRangeBecauseAlreadyWasSelected, setErrorInvalidRangeBecauseAlreadyWasSelected] = useState(false);
    const [attemptedSave, setAttemptedSave] = useState(false);
    const currentError = errors[idx];
    const onlyDay = typeof date === "number";
    const startRequiredError = attemptedSave && start <= -1;
    const endRequiredError = attemptedSave && end <= -1;
    const dateRequiredError = !onlyDay && attemptedSave && dateItem <= -1;
    const invalidTimeRangeError = attemptedSave && currentError.time.areInvalidTimes;
    //#endregion
    //#region Functions
    const checkIfRangeAlreadyWasTaken = () => {
        return inactivity.some(({ 
            time: currentTime, 
            date: currentDate,
            wasModified 
        }, currentIdx) => {
            if (idx === currentIdx || wasModified) return false;
            if (!onlyDay) {
                if (currentDate < 0) return false;
                if (dateItem !== currentDate) return false;
            }
            if ((start >= currentTime.start && end <= currentTime.end) ||
                (start <= currentTime.start && end >= currentTime.end) ||
                (start < currentTime.start && end > currentTime.start) || 
                (start < currentTime.end && end > currentTime.end)) {
                return true;
            }
            return false;
        });
    }
    const saveChangesWithValidation = () => {
        setAttemptedSave(true);

        if (startRequiredError || endRequiredError || dateRequiredError || currentError.time.areInvalidTimes) {
            setErrorInvalidRangeBecauseAlreadyWasSelected(false);
            return;
        }

        if (start >= 0 && end >= 0 && checkIfRangeAlreadyWasTaken()) {
            setErrorInvalidRangeBecauseAlreadyWasSelected(true);
            return;
        }

        setErrorInvalidRangeBecauseAlreadyWasSelected(false);
        setAttemptedSave(false);
        saveChanges(idx);
    }
    const changeTimeItem = (field, value) => {
        setErrorInvalidRangeBecauseAlreadyWasSelected(false);
        changeTime(idx, field, value, true);
    }
    const changeDateItem = value => {
        setErrorInvalidRangeBecauseAlreadyWasSelected(false);
        changeDate(idx, value);
    }
    //#endregion
    return (
        <Column>
        <StyledListTimeItem
            align={invalidTimeRangeError ? "center" : "flex-end"}>
            <Row align="flex-start">
                <Column width="max-width">
                    <Row>
                        <CustomTime 
                            label="Desde:"
                            caption="Desde:"
                            value={start}
                            onChange={value => changeTimeItem("start", value)}
                            error={currentError.time.start || startRequiredError || invalidTimeRangeError}
                            interval={intervalTimePicker}
                            ratioMinutesTime={ratioMinutesTime}
                            errorText={!invalidTimeRangeError ? 
                                "Es necesario seleccionar una hora inicial."
                            : null}
                            />
                        <CustomTime 
                            label="Hasta:"
                            caption="Hasta:"
                            value={end}
                            onChange={value => changeTimeItem("end", value)}
                            error={currentError.time.end || endRequiredError || invalidTimeRangeError}
                            interval={intervalTimePicker}
                            ratioMinutesTime={ratioMinutesTime}
                            errorText={!invalidTimeRangeError ? 
                                "Es necesario seleccionar una hora final."
                            : null}
                            />
                    </Row>
                    <ErrorMessage 
                        error={invalidTimeRangeError}
                        text="Las horas son iguales o la hora de inicio es mayor a la de fin."/>
                </Column>
                {onlyDay 
                ? <CustomDatePicker 
                    label="Fecha"
                    value={date}
                    onChange={value => changeDateItem(value)}
                    disabled/>
                : <CustomDatePicker 
                    label="Fecha"
                    value={dateItem}
                    availableDays={[availableDay]}
                    period={{
                        min: getDatePartsByMillis(date.start),
                        max: getDatePartsByMillis(date.end)
                    }}
                    onChange={value => changeDateItem(value)}
                    error={currentError.date || dateRequiredError}
                    errorText="Es necesario seleccionar una fecha."/>}
            </Row>
            {wasModified
            ? <CustomButton 
                text="Guardar"
                size="medium"
                width="100px"
                onClick={saveChangesWithValidation}/>
            : <CustomButton 
                text="Eliminar"
                size="medium"
                width="100px"
                variant="secondary"
                icon={<TrashIcon/>}
                onClick={() => openDialogDeleteInactivityQuestion(idx)}/>}
        </StyledListTimeItem>
        <ErrorMessage 
            text={
                onlyDay
                ? "El rango de horas seleccionado ya fue tomado por otro definido"
                : "El rango de horas o fecha seleccionados ya fue tomado por otro definido"}
            error={errorInvalidRangeBecauseAlreadyWasSelected}/>
        </Column>
    );
}

export default ListTimeItem;
